import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React from 'react'
import { createMVPModal } from '../Modal'
import { ChoiceModalView, ChoiceModalViewProps } from './ChoiceModalView'

class ChoiceModal
{
	Show(props: ChoiceModalViewProps) 
	{
		NiceModal.show(createMVPModal('choice-modal', () =>
		{
			const modal = useModal()

			const viewProps = {
				...props
			}
			viewProps.clickChoice = (confirm: boolean) => 
			{
				modal.hide()
				props.clickChoice(confirm)
			}

			return <ChoiceModalView  {...viewProps}/>
		}))
	}
}

const modal = new ChoiceModal()
export default modal
